import React from 'react';

export default function LegalText({ className }) {
  return (
  <div className={`legal-text fz14@sm fz16 lh1.58 mt40 mt24@sm tac ml-auto mr-auto maw780 ${ className || ''}`}>
    The Honest Kitchen True Stories<span dangerouslySetInnerHTML={{ "__html": "&trade;" }} /> testimonials are for informational purposes only. The information is not a substitute for expert veterinary care. True Stories are written by actual customers, and represent their own observations. Results are not guaranteed, are not medically substantiated, and may not be typical for other pets.
  </div>
  );
}
